import axios from 'axios'  
 import { baseUrl } from '../../shared/baseUrl'; 
import DataService from './dataService';


 
   const dataService = DataService();
const login = async (value: any) => { 
  
  const {data}= await axios.post(baseUrl + '/api/v1/auth/signin-user', value) 
  if (data) { 
    try {    
      	// @ts-ignore 
          dataService?.setToken(data?.data?.token)  
       localStorage.setItem('user_ats', JSON.stringify(data?.data));     
      // localStorage.setItem('user', JSON.stringify(data?.data)); 
    localStorage.setItem("loginToast", JSON.stringify(data?.message)); 
  } catch (e) { 
  }
  }
  return data
}
   

// Logout user
export const logout = () => {
  localStorage.removeItem('user_ats')  
   	// @ts-ignore 
  // localStorage.removeItem('userToken')
} 


// input 
const input = async ( ) => { 
  // const inputs = localStorage.getItem('user')  
  //  @ts-ignore  
    const Items = JSON.parse(localStorage.getItem('inputs'));
  return Items
}
  
  


const authService = { 
  logout,
  login, 
  input
}

export default authService
